import { useAuthService } from "@/services/authService";

function UserSwitchInfo() {
  const { isSwitchedUser, username } = useAuthService();

  if (!isSwitchedUser) return null;

  return (
    <div className="text-center mb-3 text-danger">
      <div className="fw-bold text-danger fs-6 mb-2">Impersonating user</div>
      <div className="fs-8 text-break">{username}</div>
    </div>
  );
}

export default UserSwitchInfo;
